import { Icon } from './types';

export const FacebookIcon: Icon = (props) => (
  <svg viewBox={'0 0 24 24'} {...props}>
    <path
      d={
        'M17.585 13.569l.666-4.343h-4.167v-2.82c0-1.187.582-2.346 2.448-2.346h1.895V.362S16.707.07 15.064.07c-3.432 0-5.676 2.08-5.676 5.846v3.31H5.573v4.344h3.815v10.5h4.696v-10.5h3.5z'
      }
    />
  </svg>
);
